import { SERVICE } from '@config/environment';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { MOASHELF_PATH } from '@constant/moashelf/route-path';
import { GRIDGIO_PATH } from '@constant/gridgio/route-path';

/**
 * ###################################
 * @description common path
 * ###################################
 */
export enum ERROR_PATH {
  // root path
  HOME_PATH = '/',
}

/**
 * 서비스별 초기 경로 반환
 */
export const getInitialServicePath = () => {
  if (SERVICE === 'iyagigo') return IYAGIGO_PATH.INITIAL_SERVICE_PATH;
  if (SERVICE === 'moashelf') return MOASHELF_PATH.BEGIN_PATH;
  if (SERVICE === 'gridgio') return GRIDGIO_PATH.CHECKPOINT_PATH;
  return '/';
};
